import { EffectTypeId as EffectTypeId$1, StreamTypeId as StreamTypeId$1, SinkTypeId as SinkTypeId$1, ChannelTypeId as ChannelTypeId$1, EffectPrototype as EffectPrototype$1, CommitPrototype as CommitPrototype$1, StructuralCommitPrototype as StructuralCommitPrototype$1, Base as Base$1, StructuralBase as StructuralBase$1 } from '../../internal/Effectable.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category type ids
 */
const EffectTypeId = EffectTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
const StreamTypeId = StreamTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
const SinkTypeId = SinkTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category type ids
 */
const ChannelTypeId = ChannelTypeId$1;

/**
 * @since 2.0.0
 * @category type ids
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category prototypes
 */
const EffectPrototype = EffectPrototype$1;

/**
 * @since 2.0.0
 * @category prototypes
 */
const CommitPrototype = CommitPrototype$1;

/**
 * @since 2.0.0
 * @category prototypes
 */
const StructuralCommitPrototype = StructuralCommitPrototype$1;
const Base = Base$1;
const StructuralBase = StructuralBase$1;

/**
 * @since 2.0.0
 * @category constructors
 */
class Class extends Base {}

/**
 * @since 2.0.0
 * @category constructors
 */
class StructuralClass extends StructuralBase {}

export { ChannelTypeId, Class, CommitPrototype, EffectPrototype, EffectTypeId, SinkTypeId, StreamTypeId, StructuralClass, StructuralCommitPrototype };
